"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedHeadingStyles = void 0;

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../Constant");

var _Constant2 = require("../Dashboard/Constant");

/**
 * Global styles set in Base.js currently only apply the commonHeaderStyles to h1, h2, and h3 elements in the Dashboard flow.
 * Design approved using Poppins for all of the Typography heading components.
 * For now, they'd like to leave the Base.js styles as they are to avoid unexpected changes.
 */
var sharedHeadingStyles = (0, _styledTheming.default)('flow', {
  onboarding: "\n        font-family: ".concat(_Constant.Font.HEADER_FONT, ";\n        padding: 0;\n        margin: 0 0 8px;\n        color: ").concat(_Constant.Color.DARK_GREY, ";\n    "),
  dashboard: "\n        font-family: ".concat(_Constant.Font.SECONDARY_HEADER_FONT, ";\n        padding: 0;\n        color: ").concat(_Constant2.Color.BLACK_SOUL, ";\n    ")
});
exports.sharedHeadingStyles = sharedHeadingStyles;